import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@/shared/components/Dialog';
import { PillButton } from '@/shared/components/PillButton';
import { coinImg as coinIcon } from '@/assets';
import { GAME_ECONOMY } from 'shared-types';

// Static styles extracted to avoid recreation on each render
const entryFeeAmountStyle = {
  textShadow:
    '3px 3px 0px #000, -1px -1px 0px #000, 1px -1px 0px #000, -1px 1px 0px #000, 2px 2px 6px rgba(0,0,0,0.5)'
};

export interface PaidMatchConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  currentPoints: number;
}

export const PaidMatchConfirmationDialog = memo(function PaidMatchConfirmationDialog({
  isOpen,
  onClose,
  onConfirm,
  currentPoints
}: PaidMatchConfirmationDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      variant="yellow"
      title={t('paidConfirmation.title')}
      allowClickOutsideToClose={true}
    >
      <div className="space-y-4">
        {/* Entry Fee Display */}
        <div className="flex flex-col items-center gap-1">
          <span className="font-mind-boggle text-lg text-[#333] leading-tight">
            {t('paidConfirmation.entryFee')}
          </span>
          <div className="flex items-center gap-2">
            <span
              className="font-mind-boggle text-4xl text-[#FCD34D] leading-tight"
              style={entryFeeAmountStyle}
            >
              {GAME_ECONOMY.PAID_ENTRY_FEE}
            </span>
            <img src={coinIcon} alt="" className="w-8 h-8 object-contain" />
          </div>
        </div>

        {/* Info Text */}
        <p className="font-mind-boggle text-sm text-[#666] text-center leading-tight">
          {t('paidConfirmation.pointsDeductedInfo')}
        </p>

        {/* Current Balance */}
        <p className="font-mind-boggle text-lg text-[#333] text-center leading-tight flex items-center justify-center gap-2">
          {t('common.currentBalance')}: {currentPoints.toLocaleString()}
          <img src={coinIcon} alt="" className="w-5 h-5 object-contain" />
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col gap-2">
          <PillButton variant="yellow" onClick={onConfirm} className="w-full h-12">
            {t('paidConfirmation.confirm')}
          </PillButton>
          <PillButton variant="grey" onClick={onClose} className="w-full h-12">
            {t('paidConfirmation.cancel')}
          </PillButton>
        </div>
      </div>
    </Dialog>
  );
});

export default PaidMatchConfirmationDialog;
